import { leadStory, siteName } from "@/mocks/chigua";

const stats = [
  { num: "48+", label: "今日新增" },
  { num: "5", label: "核心栏目" },
  { num: "12w+", label: "全网热度" },
];

export default function Hero() {
  const scrollToFeed = () => {
    document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" aria-label={`${siteName}头条主稿`}>
      <div className="mx-auto max-w-7xl px-4 pt-6 md:px-6">
        <article className="group relative overflow-hidden rounded-xl bg-foreground-950 md:rounded-2xl">
          <div className="relative h-[420px] overflow-hidden md:h-[480px]">
            <img
              src={leadStory.image}
              alt={leadStory.alt}
              className="h-full w-full object-cover object-top transition duration-700 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-black/20"></div>
          </div>

          <div className="absolute inset-x-0 bottom-0 p-5 md:p-9">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-bold text-background-50">
                <i className="ri-vip-crown-fill text-accent-300"></i>
                {leadStory.eyebrow}
              </span>
              <span className="inline-flex items-center gap-1 rounded-full bg-black/40 px-3 py-1 font-label text-xs font-medium text-background-50 backdrop-blur">
                <i className="ri-flashlight-line text-accent-300"></i>
                {leadStory.tag}
              </span>
            </div>

            <h1 className="mt-3 max-w-3xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
              {leadStory.title}
            </h1>
            <p className="mt-3 hidden max-w-2xl text-sm leading-relaxed text-background-100 md:line-clamp-2">
              {leadStory.excerpt}
            </p>

            <div className="mt-4 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={scrollToFeed}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 font-label text-sm font-bold text-foreground-950 transition hover:bg-accent-600"
              >
                查看更多独家
                <i className="ri-arrow-down-line"></i>
              </button>
              <span className="inline-flex items-center gap-1.5 text-xs text-background-100">
                <i className="ri-time-line"></i>
                {leadStory.time}
              </span>
              <span className="hidden items-center gap-1.5 text-xs text-background-100 sm:inline-flex">
                <i className="ri-eye-line"></i>
                全网热度 12.4万
              </span>
            </div>
          </div>

          <span className="pointer-events-none absolute right-4 top-4 hidden rounded-md bg-background-50 px-2 py-1 font-label text-[10px] font-black tracking-[0.3em] text-primary-600 md:block">
            头条 · TOP
          </span>
        </article>

        {/* 数据条 */}
        <div className="mt-4 grid grid-cols-3 overflow-hidden rounded-xl border border-background-200 bg-background-100 md:grid-cols-3">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`flex flex-col items-center gap-1 px-4 py-3 text-center md:py-4 ${
                i > 0 ? "border-l border-background-200" : ""
              }`}
            >
              <span className="font-heading text-xl font-black text-primary-600 md:text-2xl">
                {s.num}
              </span>
              <span className="font-label text-xs text-foreground-600">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}